import _Note from './component';
import * as _actions from './actions';
import * as _accessors from './accessors';
import _reducer from './reducer';

export const Note = _Note;
export const actions = _actions;
export const reducer = _reducer;
export const accessors = _accessors;



// WEBPACK FOOTER //
// ./containers/Student/Note/index.js